import { Controller } from '@hotwired/stimulus';
import { replaceWithTiptap } from 'manage/tiptap';

export default class extends Controller {
  static values = {
    imageUploadUrl: String,
    fileUploadUrl: String,
  };

  connect() {
    this.editor = replaceWithTiptap(this.element, {
      imageUploadUrl: this.imageUploadUrlValue,
      fileUploadUrl: this.fileUploadUrlValue,
    });
  }

  disconnect() {
    this.editor?.destroy();
  }
}
